module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Contents"
    }
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('span', {
    staticClass: "small1"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "acka"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780310412625_epub_ack_r1#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c01a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780310412625_epub_c01_r1#c01"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Over the Mountain")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c02a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780310412625_epub_c02_r1#c02"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Daily Bread")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c03a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780310412625_epub_c03_r1#c03"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Through the Valley")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c04a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9780310412625_epub_c04_r1#c04"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Wife of My Youth")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c05a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c05_r1#c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Answering the Call")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c06a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c06_r1#c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("The Hour of Trial")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c07a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c07_r1#c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Fall of the Mighty")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c08a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c08_r1#c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Requiem")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c09a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c09_r1#c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("The Dark Times")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c10a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c10_r1#c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Bugs and the Band")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c11a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c11_r1#c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 11")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Trudge to the Rappahannock")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c12a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c12_r1#c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 12")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("A Carol for Caroline Street")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c13a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c13_r1#c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 13")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Plain of the Dead")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c14a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c14_r1#c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 14")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("The Endless Night")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c15a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c15_r1#c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 15")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Tears in the Yuletide")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c16a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c16_r1#c16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 16")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("General Decline")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c17a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c17_r1#c17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 17")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("General Renewal")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c18a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c18_r1#c18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 18")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("A Grand Design")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c19a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c19_r1#c19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 19")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("The Inn at the Crossroad")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c20a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c20_r1#c20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 20")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("A Knock on the Head")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c21a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c21_r1#c21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 21")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Northward Bound")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c22a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c22_r1#c22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 22")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Northward Bound Again")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c23a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c23_r1#c23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 23")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Bliss")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c24a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c24_r1#c24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 24")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Dust and Ashes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c25a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c25_r1#c25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 25")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("New Recruits")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c26a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c26_r1#c26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 26")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Dry Powder")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c27a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c27_r1#c27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 27")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Back to the Enemy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c28a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c28_r1#c28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 28")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Winter Quarters")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c29a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c29_r1#c29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 29")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Eye to Eye")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c30a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c30_r1#c30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 30")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("A Season in the Wilderness")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c31a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c31_r1#c31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 31")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("The Mule Shoe")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c32a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c32_r1#c32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 32")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Assault at Cold Harbor")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c33a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c33_r1#c33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 33")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Her Husband’s Crown")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "c34a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9780310412625_epub_c34_r1#c34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sm2"
  }, [_vm._v("CHAPTER 34")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "big2"
  }, [_c('em', [_vm._v("Unto the Mountains")])])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindenttoc",
    attrs: {
      "id": "atpa"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/AboutthePublisher#atp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69af3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780310412625_epub_toc_r1.vue
// module id = 72
// module chunks = 0